import Card from '../../components/Card/Card'
import ModalForm from '../../components/Form/ModalForm'
import './Services.css'

import img1 from './img/Analytics.svg'
import img2 from './img/Documents.svg'
import img3 from './img/Gear.svg'
import img4 from './img/hand.svg'
import img5 from './img/code.svg'
import img6 from './img/wrench-screwdriver.svg'
import Footer from '../../components/Footer/Footer'


export default function Services() {
    return (
        <main className="services">
            <div className="services__text">
                <h2>Наши услуги</h2>
                <p>Мы разрабатываем <span>«под ключ»</span>
                    <br />
                    Нам не важно открываете ли Вы <span>новый бизнес</span> или хотите <span>модернизировать,
                    автоматизировать и оптимизировать</span> уже не один год работающий бизнес - нам важно <span>принести
                    Вам новые знания или возможности</span> и получить от Вас <span>новый опыт</span>.
                </p>
            </div>
            <div className="services__card">
                <Card
                    title="Исследование"
                    img={
                        img1
                    }
                    text="// Мы посмотрим на ваш бизнес свежим взглядом и найдём, как сделать его лучше и эффективнее."

                />
                <Card
                    title="Документация"
                    img={
                        img2
                    }
                    text="// Мы поможем составить техническое задание, которое понятно выразит ваши желания и устроит всех."

                />
                <Card
                    title="Инструменты"
                    img={
                        img6
                    }
                    text="// Найдём подходящие инструменты для автоматизации, чтобы вам не пришлось разбираться во всём самостоятельно."

                />
                <Card
                    title="Комплектующие"
                    img={
                        img3
                    }
                    text="// Обеспечим подбор и поставку всего необходимого аппаратного обеспечения."

                />
                <Card
                    title="Разработка"
                    img={
                        img5
                    }
                    text="// Совместная разработка ТЗ помогает нам быстро создать решение под вашу задачу."
                />
                <Card
                    title="Сотрудничество"
                    img={
                        img4
                    }
                    text="// Мы нацелены на долгосрочное партнерство без необходимости держать собственный IT-штат."

                />
            </div>

            <div className="services__form">
                <ModalForm />
            </div>
                    
            <Footer />
        </main>
    )
}
